import actions from "actions";

const initialState = {
  email: "",
  password: "",
  challengeResponse: null,
  error: "",
};

function entry(state = initialState, action) {
  switch (action.type) {
    case actions.entry.CLEAR:
      return { ...initialState };
    case actions.entry.UPDATE_EMAIL:
      return { ...state, email: action.email };
    case actions.entry.UPDATE_CHALLENGE_RESPONSE:
      return { ...state, challengeResponse: action.challengeResponse };
    case actions.entry.UPDATE_ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
}

export default entry;
